import React from 'react';
import t from 'prop-types';
import { FormattedMessage } from 'react-intl';

import CookieImage from '../../../assets/icons/cookies.png';

import styles from './CookieBanner.scss';

const blackListRoutes = ['/diia/success'];

const CookieBanner = ({ onCookieConsent }) => {
  return blackListRoutes.includes(location.pathname)
    ? null
    : (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <img src={CookieImage} className={styles.cookieImage} alt="" />
          <div className={styles.text}>
            <FormattedMessage
              id="layout.cookieDisclaimer.text"
              defaultMessage={
                'ClearVPN uses cookies to personalize your experience on our website. '
            + 'By continuing to use this site, you agree to our cookie policy. '
            + 'Click <link>here</link> to learn more.'
              }
              description="Cookie banner informing about Cookie usage"
              values={{ link: (chunk) => (<a href="https://macpaw.com/cookies">{chunk}</a>) }}
            />
          </div>
          <button className={styles.confirmButton} onClick={onCookieConsent}>
            <FormattedMessage
              id="layout.cookieDisclaimer.confirmButton"
              defaultMessage="Ok"
              description="Confirm button, dismisses Cookie banner"
            />
          </button>
        </div>
      </div>
    );
};

CookieBanner.propTypes = {
  onCookieConsent: t.func.isRequired
};

export default CookieBanner;
